import { yupResolver } from '@hookform/resolvers/yup';
import Image from 'next/image';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import closeIcon from '@/assets/images/icons/close-icon.svg';

type CardForm = {
  name: string;
  cardNumber: string;
  expiryDate: string;
  cvv: string;
};

export const AddCardModal = () => {
  const cardSchema = yup.object({
    name: yup.string().required('*Required'),
    cardNumber: yup.string().required('*Required'),
    expiryDate: yup.string().required('*Required'),
    cvv: yup.string().required('*Required'),
  });
  const {
    register: cardDetailsData,
    formState: { errors: cardErrors },
  } = useForm<CardForm>({
    defaultValues: {
      name: '',
      cardNumber: '',
      expiryDate: '',
      cvv: '',
    },
    resolver: yupResolver(cardSchema),
  });

  return (
    <div
      className="modal loanDetails__modal addressDetail__modal fade"
      id="cardPop"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="cardPopLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal__title">
            <p className="text--semi text--black sell_p">Add Card Details</p>
            <a data-dismiss="modal">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={closeIcon}
                alt="close icon"
              />
            </a>
          </div>
          <div className="interestDetail">
            <form autoComplete="off" onSubmit={() => {}}>
              <div className="form-row">
                <div className="form-group col">
                  <div className="input-container">
                    <label className="text--regular text--black" htmlFor="noc">
                      Name on Card
                    </label>
                    <div className="input-form">
                      <input
                        type="text"
                        placeholder="Eg: Radha Shrivastava"
                        id="noc"
                        {...cardDetailsData('name')}
                      />
                    </div>
                    {/* <p className="text--red text--regular errorMessage">
                        Error
                      </p> */}
                    {cardErrors.name && (
                      <p className="text--red sell_p">
                        {cardErrors?.name.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col">
                  <div className="input-container">
                    <label
                      className="text--regular text--black"
                      htmlFor="cardNumber"
                    >
                      Enter Card Number
                    </label>
                    <div className="input-form">
                      <input
                        type="text"
                        placeholder="Eg: 1234-1234-1234-1234"
                        id="cardNumber"
                        {...cardDetailsData('cardNumber')}
                      />
                    </div>
                    {/* <p className="text--red text--regular errorMessage">
                        Error
                      </p> */}
                    {cardErrors?.cardNumber && (
                      <p className="text--red sell_p">
                        {cardErrors?.cardNumber.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6 col-12">
                  <div className="input-container">
                    <label
                      className="text--regular text--black"
                      htmlFor="expiryDate"
                    >
                      Expiry Date
                    </label>
                    <div className="input-form">
                      <input
                        type="text"
                        placeholder="MM/YYYY"
                        id="expiryDate"
                        {...cardDetailsData('expiryDate')}
                      />
                    </div>
                    {/* <p className="text--red text--regular errorMessage">
                        Error
                      </p> */}
                    {cardErrors?.expiryDate && (
                      <p className="text--red sell_p">
                        {cardErrors?.expiryDate?.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="form-group col-md-6 col-12">
                  <div className="input-container">
                    <label className="text--regular text--black" htmlFor="cvv">
                      CVV
                    </label>
                    <div className="input-form">
                      <input
                        type="password"
                        placeholder="***"
                        id="cvv"
                        {...cardDetailsData('cvv')}
                      />
                    </div>
                    {/* <p className="text--red text--regular errorMessage">
                        Error
                      </p> */}
                    {cardErrors?.cvv && (
                      <p className="text--red sell_p">
                        {cardErrors?.cvv?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="action-container">
                {/* <a
                    href="#"
                    className="custom__button custom__button--dark text--semi w-100 ml-0"
                    data-dismiss="modal"
                  > */}
                <button
                  type="submit"
                  className="custom__button custom__button--dark text--semi w-100 ml-0"
                  id="DG_card-verify"
                >
                  Verify & Add
                </button>

                {/* </a> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
